export var getValueByName = function (values, name) {
    var _a, _b;
    if (!values.length) {
        return null;
    }
    return (_b = (_a = values.find(function (_a) {
        var valueName = _a.name;
        return valueName === name;
    })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null;
};
export var currentUserFactory = function (currentUserResponse) {
    var _a;
    var responseUser = (_a = currentUserResponse === null || currentUserResponse === void 0 ? void 0 : currentUserResponse.CurrentUser) === null || _a === void 0 ? void 0 : _a.userProfile;
    var currentUser = {};
    if (!responseUser) {
        return null;
    }
    var userValues = responseUser.values;
    var findValueByName = getValueByName.bind(null, userValues);
    currentUser.firstName = findValueByName('firstName');
    currentUser.lastName = findValueByName('lastName');
    currentUser.gender = findValueByName('gender');
    currentUser.id = responseUser.id;
    return currentUser;
};
